import { render } from "./TypesView.vue?vue&type=template&id=40a8745d"
import script from "./TypesView.vue?vue&type=script&lang=js"
export * from "./TypesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__